'use client'

import Link from 'next/link'

interface ILinkProp {
  href: string
  variant?: string
  text: string
}

const LinkButton: React.FC<ILinkProp> = ({ href, variant, text }) => {
  return (
    <Link href={href} passHref>
      <h6
        className={
          variant === 'ghost'
            ? 'text-sm font-semibold leading-[24px] text-primary-yellow-main underline'
            : ''
        }
      >
        {text}
      </h6>
    </Link>
  )
}

export default LinkButton
